import React, { useCallback, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { AnnaBoot } from './AnnaBoot';
const KEY = 'anna-booted';

/** Plays the boot sequence once per session, over whichever screen opens first. */
export function BootGate({
  enabled,
  children
}: {
  enabled: boolean;
  children: React.ReactNode;
}) {
  const [booting, setBooting] = useState(() => enabled && typeof window !== 'undefined' && !window.sessionStorage.getItem(KEY));
  const done = useCallback(() => {
    window.sessionStorage.setItem(KEY, '1');
    setBooting(false);
  }, []);
  return <>
      {children}
      <AnimatePresence data-id="element-534" data-mp="1k6tam7l1u7ja">{booting && <AnnaBoot key="boot" onDone={done} data-id="element-535" data-mp="1k61ix7ukotya" />}</AnimatePresence>
    </>;
}